<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.questions.headerTitle')" />

    <div class="base-container-first questions__container">
      <FaqLinkBlock />
    </div>

    <div class="base-container-first questions__wrapper">
      <ul class="questions__list">
        <template
          v-for="(question, questionIndex) in QUESTIONS"
          :key="questionIndex"
        >
          <li>
            <BaseAccordion class="ui-accordion-primary">
              <template #title>
                <span class="questions-item__title typography__title1">{{ question.title }}</span>
              </template>

              <template #button="{ show }">
                <BaseIcon2
                  :id="show ? 'icon-minus-circle' : 'icon-plus-circle'"
                  class="accordion__item-icon"
                  :color="show ? 'var(--grey-1)' : 'var(--grey-3)'"
                  height="20"
                  width="20"
                />
              </template>

              <template #content>
                <p class="typography__body1" v-html="question.answer" />
              </template>
            </BaseAccordion>
          </li>

          <li v-if="questionIndex !== QUESTIONS.length - 1">
            <BaseDivider class="ui-divider-primary" />
          </li>
        </template>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.questions.contact.description')"
    :title="t('pages.questions.contact.title')"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();

const QUESTIONS = [
  {
    answer: t("pages.questions.list.1.answer"),
    title: t("pages.questions.list.1.title"),
  },
  {
    answer: t("pages.questions.list.2.answer"),
    title: t("pages.questions.list.2.title"),
  },
  {
    answer: t("pages.questions.list.3.answer"),
    title: t("pages.questions.list.3.title"),
  },
  {
    answer: t("pages.questions.list.4.answer"),
    title: t("pages.questions.list.4.title"),
  },
  {
    answer: t("pages.questions.list.5.answer"),
    title: t("pages.questions.list.5.title"),
  },
  {
    answer: t("pages.questions.list.6.answer"),
    title: t("pages.questions.list.6.title"),
  },
  {
    answer: t("pages.questions.list.7.answer"),
    title: t("pages.questions.list.7.title"),
  },
  {
    answer: t("pages.questions.list.8.answer"),
    title: t("pages.questions.list.8.title"),
  },
];

useSeoMeta({
  title: t("pages.questions.seo.title"),
});
</script>

<style scoped>
.questions__container {
  margin: 0 auto;
  padding-top: 0;
  padding-bottom: 80px;
}

@media (--desktop) {
  .questions__container {
    padding-bottom: 120px;
  }
}

.questions__wrapper {
  display: flex;
  flex-direction: column;
  margin: 0 auto 80px;
  padding-top: 0;
}

@media (--desktop) {
  .questions__wrapper {
    margin-bottom: 120px;
  }
}

.questions__list {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 100%;
}

.questions-item__title {
  text-align: left;
}

:deep(.questions__list .c-accordion__button) {
  align-items: flex-start;
  column-gap: 16px;
}

.accordion__item-icon {
  flex-shrink: 0;
}

@media (--hover) {
  :deep(.questions__list .c-accordion__button:hover .accordion__item-icon) {
    color: var(--grey-1);
  }
}
</style>
